import { useState, useEffect } from "react";
import "./ContactModal.css";

// Try to import EmailJS, but make it optional
let emailjs = null;
try {
  emailjs = require("@emailjs/browser");
} catch (e) {
  // EmailJS not installed, will use mailto fallback
  console.log("EmailJS not available, using mailto fallback");
}

export default function ContactForm({ onSuccess }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Initialize EmailJS if available
  useEffect(() => {
    if (emailjs) {
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
      if (publicKey && publicKey !== "YOUR_PUBLIC_KEY") {
        emailjs.init(publicKey);
      }
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Try PHP backend first (for Hostinger hosting)
      try {
        const response = await fetch('/send-email.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            message: formData.message,
          }),
        });

        const result = await response.json();
        
        if (result.success) {
          setSubmitStatus("success");
          setTimeout(() => {
            onSuccess();
          }, 2000);
          setIsSubmitting(false);
          return;
        }
      } catch (phpError) {
        console.log("PHP backend not available, trying EmailJS...");
      }

      // Fallback to EmailJS if PHP backend fails
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || "YOUR_SERVICE_ID";
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "YOUR_TEMPLATE_ID";
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "YOUR_PUBLIC_KEY";

      if (emailjs && serviceId !== "YOUR_SERVICE_ID" && templateId !== "YOUR_TEMPLATE_ID" && publicKey !== "YOUR_PUBLIC_KEY") {
        await emailjs.send(
          serviceId,
          templateId,
          {
            from_name: formData.name,
            from_email: formData.email,
            phone: formData.phone,
            message: formData.message,
            to_email: "a.simon@speakwithsimon.com",
          },
          publicKey
        );
        setSubmitStatus("success");
        setTimeout(() => {
          onSuccess();
        }, 2000);
      } else {
        // If PHP and EmailJS both fail, show error
        throw new Error("Email service not available. Please contact us directly at a.simon@speakwithsimon.com");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form-wrapper">
      <h2>Send us a message</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Your name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="your.email@example.com"
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="(555) 123-4567"
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message *</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="6"
            placeholder="Tell us how we can help you..."
          />
        </div>

        {submitStatus === "success" && (
          <div className="form-status success">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            Message sent successfully!
          </div>
        )}

        {submitStatus === "error" && (
          <div className="form-status error">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            There was an error sending your message. Please try again or use the mailto link.
          </div>
        )}

        <button
          type="submit"
          className="contact-form-submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Sending..." : "Send Message"}
        </button>
      </form>
    </div>
  );
}

